export default {
  title: {
    id: 'bo_sellers-orders-drawers-financial-details-table-title',
    defaultMessage: 'Financial details for #{orderId}',
  },
  taxEcludedAmount: {
    id: 'bo_sellers-orders-drawers-financial-details-tax-excluded-amount',
    defaultMessage: 'Amount (excl. tax)',
  },
  taxAmount: {
    id: 'bo_sellers-orders-drawers-financial-details-tax-amount',
    defaultMessage: 'VAT',
  },
  taxIncludedAmount: {
    id: 'bo_sellers-orders-drawers-financial-details-tax-included-amount',
    defaultMessage: 'Amount (incl. tax)',
  },
  payableBalance: {
    id: 'bo_sellers-orders-drawers-financial-details-payable-balance',
    defaultMessage: 'Payable balance',
  },
}
